import React, { useState, useEffect } from 'react';
import UI from '../../ui';
import { Instructions } from '../Instructions';
import { ValidationErrors } from '../Validations';
import { InboundStatus, ShippingStatus } from '../Status';
import { PackingMethodIdMap } from '../Mappings';

const { WrappedTooltip } = UI;

const PackingMethod = ({
	onPackingMethodChange,
	updateInboundInstructions,
	packagingType,
	inboundStatus,
	shippingMethod,
	saveDefaultInboundSelection,
	isMobile,
	validations,
	updateValidation,
}) => {
	const [packingMethod, setPackingMethod] = useState(
		shippingMethod === ShippingStatus.Zorbit ? PackingMethodIdMap.Boxes : packagingType
	);
	const disablePackingMethod =
		inboundStatus === InboundStatus.Processing ||
		inboundStatus === InboundStatus.Completed ||
		inboundStatus === InboundStatus.Cancelled;

	useEffect(() => {
		setPackingMethod(packagingType);
	}, [packagingType]);

	const onPackingMethodSelection = e => {
		const selectedMethod = e.target.getAttribute('name');
		const selectedMethodValue =
			PackingMethodIdMap[selectedMethod === 'boxes' ? 'Boxes' : 'Pallet'];
		const updatedValidations = validations;

		saveDefaultInboundSelection('packagingType', selectedMethodValue);
		setPackingMethod(selectedMethodValue);
		onPackingMethodChange({ packagingType: selectedMethodValue });

		updatedValidations.packingMethod = 1;
		updateValidation(updatedValidations);
	};

	const onButtonFocus = () => {
		updateInboundInstructions(
			Instructions.headers.inbound.packingMethod,
			Instructions.instructions.inbound.packingMethod
		);
	};

	const editablePackingMethod = (
		<>
			<div className="packing-title">
				<span>Packing Method</span>
			</div>
			<div className="package-buttons p-grid p-col-12 p-dir-col">
				<button
					type="button"
					name="boxes"
					className={`packing-button p-lg-6 ${
						packingMethod === PackingMethodIdMap.Boxes ? 'selected' : ''
					} ${validations.packingMethod === -1 ? 'invalid-component' : ''}`}
					onClick={onPackingMethodSelection}
					onFocus={onButtonFocus}
					data-qa="packing-method-boxes"
					{...{ dataqa: 'packing-method-boxes' }}
				>
					<div className="packing-image boxes" name="boxes" />
					<div
						className={`package-text ${
							packingMethod === PackingMethodIdMap.Boxes ? 'selected' : ''
						}`}
						name="boxes"
					>
						Boxes
					</div>
				</button>

				<button
					type="button"
					name="pallet"
					className={`packing-button p-lg-6 pallet ${
						packingMethod === PackingMethodIdMap.Pallet ? 'selected' : ''
					} ${validations.packingMethod === -1 ? 'invalid-component' : ''}`}
					onClick={onPackingMethodSelection}
					onFocus={onButtonFocus}
					disabled={shippingMethod === ShippingStatus.Zorbit}
					data-qa="packing-method-pallets"
					{...{ dataqa: 'packing-method-pallets' }}
				>
					<div className="packing-image pallet" name="pallet" />
					<div
						className={`package-text ${
							packingMethod === PackingMethodIdMap.Pallet ? 'selected' : ''
						}`}
						name="pallet"
					>
						Pallets
					</div>
				</button>
			</div>
		</>
	);

	const nonEditablePackingMethod = (
		<>
			<div className="packing-title read-only-label-container">
				<div className="read-only-label">Packing Method</div>
			</div>
			<div className="package-buttons p-grid p-col-12 p-dir-col">
				<button
					type="button"
					name={packingMethod}
					className={`packing-button uneditable p-lg-6 selected ${
						packingMethod === PackingMethodIdMap.Pallet ? 'pallet' : 'boxes'
					}`}
				>
					<div
						className={`packing-image ${
							packingMethod === PackingMethodIdMap.Pallet ? 'pallet' : 'boxes'
						}`}
						name={packingMethod === PackingMethodIdMap.Pallet ? 'pallet' : 'boxes'}
					/>
					<div
						className="package-text selected"
						name={packingMethod === PackingMethodIdMap.Pallet ? 'pallet' : 'boxes'}
					>
						{packingMethod === PackingMethodIdMap.Pallet ? 'Pallets' : 'Boxes'}
					</div>
				</button>
			</div>
		</>
	);

	return (
		<div
			className={`packing-method ${
				inboundStatus === InboundStatus.Processing ? 'processing' : ''
			}`}
		>
			{!disablePackingMethod && editablePackingMethod}
			{disablePackingMethod && nonEditablePackingMethod}

			{validations.packingMethod === -1 && !isMobile && (
				<div className="packing-error-container">
					<div className="invalid-error-icon packing-error-icon" />
					<WrappedTooltip
						tooltip={ValidationErrors.packingMethodRequired}
						target="packing-error-icon"
						position="right"
						className="tooltip-error"
					/>
				</div>
			)}
			{validations.packingMethod === -1 && isMobile && (
				<div className="packing-error-container packing-error-text">
					<div className="packing-filler" />
					<div className="invalid-error-icon" />
					<span className="error-msg">{ValidationErrors.packingMethodRequired}</span>
				</div>
			)}
		</div>
	);
};

export default PackingMethod;
